"use strict";

exports.subordinationTypesHash = {
  mincult: 'mincult',
  federal: 'federal',
  departmental: 'departmental',
  commercial: 'commercial',
  regional: 'regional',
  municipal: 'municipal'
};
exports.subordinationTypeTitlesHash = {
  mincult: 'Библиотеки МКРФ',
  federal: 'Федеральные',
  departmental: 'Ведомственные',
  commercial: 'Частные',
  regional: 'Региональные',
  municipal: 'Муниципальные'
};
exports.instituteTypesHash = {
  theater: 'theater',
  library: 'library',
  museum: 'museum',
  concertVenue: 'concertVenue',
  religionHeritage: 'religionHeritage',
  architecture: 'architecture',
  manor: 'manor',
  educational: 'educational',
  hc: 'hc',
  russiaImages: 'russiaImages',
  educationalInstitutes: 'educationalInstitutes',
  park: 'park',
  circus: 'circus',
  zoo: 'zoo',
  cinema: 'cinema'
};
exports.instituteTypeTitlesHash = {
  theater: 'Театр',
  library: 'Библиотека',
  museum: 'Музей',
  concertVenue: 'Концертная площадка',
  religionHeritage: 'Культурное наследие',
  architecture: 'Архитектура',
  manor: 'Усадьба',
  educational: 'Образовательное учреждение',
  hc: "\u0414\u043E\u043C \u043A\u0443\u043B\u044C\u0442\u0443\u0440\u044B \u0438\xA0\u043A\u043B\u0443\u0431",
  russiaImages: 'Образ России',
  educationalInstitutes: 'Образовательное учреждение',
  park: 'Парк',
  circus: 'Цирк',
  zoo: 'Зоопарк',
  cinema: 'Кинотеатр'
};
exports.instituteRubricToTitlesHash = {
  'theaters/institutes': 'Театры',
  'literature/libraries': 'Библиотеки',
  'museums/institutes': 'Музеи',
  'music/concert-venues': 'Концертные площадки',
  'traditions/religion-heritage': 'Религиозное наследие',
  'traditions/culture-heritage': 'Культурное наследие',
  'architecture/institutes': 'Архитектура',
  'architecture/manors': 'Усадьбы',
  'lectures/educational': 'Образовательные учреждения',
  'traditions/doma-kultury-i-kluby': "\u0414\u043E\u043C\u0430 \u043A\u0443\u043B\u044C\u0442\u0443\u0440\u044B \u0438\xA0\u043A\u043B\u0443\u0431\u044B",
  russia: 'Образы России',
  'visit/circuses': 'Цирки',
  'visit/parks': 'Парки',
  'visit/zoos': 'Зоопарки'
};
exports.instituteTypeGenderHash = {
  theater: 'male',
  library: 'female',
  museum: 'male',
  concertVenue: 'female',
  religionHeritage: 'neuter',
  architecture: 'female',
  manor: 'female',
  musicalGroup: 'female',
  educational: 'neuter',
  hc: 'male',
  russiaImages: 'male',
  educationalInstitutes: 'neuter',
  park: 'male',
  circus: 'male',
  zoo: 'male'
};
exports.theaterAudiencesHash = {
  children: 'children',
  youth: 'youth',
  young_spectator: 'young_spectator'
};
exports.theaterAudienceTitlesHash = {
  children: 'Детский',
  youth: 'Молодёжный',
  young_spectator: 'Юного зрителя'
};
exports.theaterLevelsHash = {
  amateur: 'amateur',
  professional: 'professional',
  instructional: 'instructional',
  young_actor: 'young_actor'
};
exports.theaterLevelTitlesHash = {
  amateur: 'Любительский',
  professional: 'Профессиональный',
  instructional: 'Учебный',
  young_actor: 'Юного актёра'
};
exports.theaterLanguagesHash = {
  russian: 'russian',
  national: 'national',
  other: 'other'
};
exports.theaterLanguageTitlesHash = {
  russian: 'Русский',
  national: 'Национальный',
  other: 'Другой'
};
exports.organizationTypesHash = {
  mincult: 'mincult',
  control: 'control',
  mineduc: 'mineduc',
  commercial: 'commercial',
  othergov: 'othergov',
  mindef: 'mindef',
  virtual: 'virtual'
};
exports.organizationTypesTitlesHash = {
  mincult: 'Минкультуры России',
  control: 'Контролирующая организация',
  mineduc: 'Минобрнауки России',
  noncommercial: 'Некоммерческая организация',
  commercial: 'Негосударственные',
  othergov: 'Другие государственные',
  mindef: 'Минобороны России',
  virtual: 'Виртуальная организация'
};